// theme.js
import tinycolor from "tinycolor2"
function makeScale(base) {
  const tc = tinycolor(base)
  console.log("tc :>> ", tc)
  return [
    tc.toRgbString(), //  0: Base
    tc.darken(4).toRgbString(), //  1: Darken 4%
    tc.darken(5).toRgbString(), //  2: Darken 5%
    tc.setAlpha(0.2).toRgbString(), //  3: Fade 20%
    tc.lighten(3).toRgbString(), //  4: Lighten 3%
    tc.setAlpha(0.75).toRgbString(), // 5: Fade 75%
    tc.lighten(15).toRgbString(), //  6: Lighten 15%
    tc.lighten(12).toRgbString(), //  7: Lighten 12%
    tc.darken(2).toRgbString(), //  8: Darken 2%
  ]
}
const colorConfig = {
  primary: typeof PRIMARY_COLOR === "string" ? PRIMARY_COLOR : "#17223b",
  secondary: typeof SECONDARY_COLOR === "string" ? SECONDARY_COLOR : "#263859",

  primaryFont:
    typeof PRIMARY_FONT_COLOR === "string" ? PRIMARY_FONT_COLOR : "#F9F9F9",
  secondaryFont:
    typeof SECONDARY_FONT_COLOR === "string" ? SECONDARY_FONT_COLOR : "#ffffff",

  button: typeof BUTTON_COLOR === "string" ? BUTTON_COLOR : "",
  sideBarHeader:
    typeof SIDEBAR_HEADER_COLOR === "string"
      ? SIDEBAR_HEADER_COLOR
      : "rgba(0, 0, 0, 0.3)",
}
console.log("colorConfig :>> ", colorConfig)
const defaultPrimary = [
  "#4482FF", // 0: Default
  "#3A78F5", // 1: Darken 4%
  "#3775F2", // 2: Darken 5%
  "rgba(68, 130, 255, 0.2)", // 3: Fade 20%
  "#4C8AFF", // 4: Lighten 3%
  "rgba(68, 130, 255, 0.75)", // 5: Fade 75%
  "#6AA8FF", // 6: Lighten 15%
  "#63A1FF", // 7: Lighten 12%
  "#3F7DFA", // 8: Darken 2%
  "#3369e7", // 9: Algolia color
  "#5896FF", // 10: Lighten 8%
  "#2b69e6", // 11:
  "#236cfe", // 12: darken 10%
  "#4d88ff", // 13: Lighten 5%
]

const defaultSecondary = [
  "#17223b", // 0: DarkBlue
  "#f1f3f6", // 1: LightBluish
  "#788195", // 2: LightBlue
  "#E4E6E9", // 3: LightBluish Darken 5%
  "#364d79", // 4:
  "#202739", // 5: DarkBlue Darken 5%
  "#f5f6f8", // 6: LighterBluish
  "#e9ebf1", // 7: DarkBluish
  "#F6F8FB", // 8: LighterBluish Lighten 2%
  "#E9EBEE", // 9: LighterBluish Darken 3%
  "#1a1a1a", // 10: Sidebar submenu select
]

const theme = {
  palette: {
    theme: [colorConfig.primary],
    darkTheme: [colorConfig.primary, colorConfig.secondary, "#6b778d"],

    primary: defaultPrimary,
    primaryFont: makeScale(colorConfig.primary),

    secondary: defaultSecondary,
    secondaryFont: makeScale(colorConfig.secondaryFont),

    sideBarHeader: makeScale(colorConfig.sideBarHeader),
    button: colorConfig.button ? makeScale(colorConfig.button) : defaultPrimary,

    // all other scales remain as before
    color: [
      "#FEAC01",
      "#42299a",
      "#F75D81",
      "#7ED321",
      "#39435f",
      "#FFCA28",
      "#F2BD1B",
      "#3b5998",
      "#344e86",
      "#dd4b39",
      "#d73925",
      "#e14615",
      "#ca3f13",
      "#e0364c",
    ],
    warning: ["#ffbf00"],
    success: ["#00b16a"],
    error: ["#f64744", "#EC3D3A", "#FF5B58"],
    grayscale: [
      "#bababa",
      "#c1c1c1",
      "#D8D8D8",
      "#f1f1f1",
      "#F3F3F3",
      "#fafafa",
      colorConfig.primaryFont,
      "#fcfcfc",
      "#eeeeee",
      "#fbfbfb",
      "#f5f5f5",
      "#f7f8f9",
      "#222222",
    ],
    text: ["#323332", "#595959", "#979797", "#797979", "#6a6c6a", "#ffffff"],
    border: [
      "#e9e9e9",
      "#d8d8d8",
      "#ebebeb",
      "#d3d3d3",
      "rgba(228, 228, 228, 0.65)",
    ],
    calendar: ["#905", "#690", "#a67f59", "#07a", "#dd4a68", "#e90"],
  },

  fonts: {
    primary: "Roboto, sans-serif",
    pre: "Consolas, Liberation Mono, Menlo, Courier, monospace",
  },
}
console.log({ theme })
export default theme
